const prod = {
  url: {
    API_BASE_URL: 'https://stocky-backend-xw1z.onrender.com',
  }
}

const dev = {
  url: {
    API_BASE_URL: 'http://localhost:8080'
  }
}

export const config = process.env.NODE_ENV === 'development' ? dev : prod
